import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
const mistakes = [{
  title: 'Los jugos "Detox" verdes',
  desc: 'Están cargados de fructosa liquida que estresa tu hígado y dispara la inflamación.'
}, {
  title: 'Las dietas ricas en fibra cruda',
  desc: 'Actúan como lija sobre un intestino que ya está irritado y sensible.'
}, {
  title: 'Los productos "light"',
  desc: 'Sustituyen grasas por químicos y edulcorantes que alteran tu microbiota en segundos.'
}, {
  title: 'Comer "un poco de todo"',
  desc: 'Impide que tu sistema inmunológico identifique qué alimento específico está causando el fuego.'
}];
export function MistakesSection() {
  return <section className="py-24 bg-mint/30" data-id="element-151">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-152">
        <FadeIn data-id="element-153">
          <div className="text-center mb-16" data-id="element-154">
            <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-155">
              Por qué lo que has intentado no funciona
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-156">
              Probablemente has intentado hacer las cosas "bien", pero la
              industria del bienestar a menudo recomienda soluciones que
              empeoran el problema.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-157">
          {mistakes.map((mistake, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-158">
              <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 flex gap-4 h-full transition-all hover:shadow-md" data-id="element-159">
                <div className="flex-shrink-0 mt-1" data-id="element-160">
                  <XCircle className="w-6 h-6 text-red-400" strokeWidth={2} data-id="element-161" />
                </div>
                <div data-id="element-162">
                  <h3 className="text-xl font-bold text-forest mb-2 font-sans" data-id="element-163">
                    {mistake.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-164">
                    {mistake.desc}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}